import { Info, SyncAlt, PlayCircleOutline, AddShoppingCart, StarRate } from '@mui/icons-material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Button } from '@mui/material';
import React from 'react';
import './home.css';
import Banner from './Banner';
import Products from './Products';
import Client from './Client';
import Contactus from './Contactus';
import Cards from './Cards';
import Testimonial from './Testimonial';

const productItems = [
  {
    title: 'Spheres NG',
    info: 'Shop for all your baby needs between ages 1-6',
    imageUrl: '/spheresbg.jpg',
    logoUrl: '/sphereslogo.png',
    linkUrl: 'https://spheres.ng',
  },
  {
    title: 'BeauMe',
    info: 'All the styles and all the fashion',
    imageUrl: '/beaumebg.jpg',
    logoUrl: '/ViewJot-logo.png',
    linkUrl: 'https://beaume.com',
  },
  {
    title: 'View Autos',
    info: 'Modern mobility solutions built around convenience and trust.',
    imageUrl: '/viewautosbg.jpg',
    logoUrl: '/viewautoslogo.png',
    linkUrl: 'https://viewautos.com',
  },
  {
    title: 'View Homes',
    info: 'Thoughtful living experiences designed for comfort and growth.',
    imageUrl: '/viewhomesbg.jpg',
    logoUrl: '/ViewJot-logo.png',
    linkUrl: '',
  },
];

function Home({ onNavigate }) {
  return (
    <div className='home'>
      <div className='bnf'>
        <Banner onNavigate={onNavigate} />
      </div>

      <div className='cardrow' id='services'>
        <Cards
          Icon={SyncAlt}
          title='IT PRODUCT DEVELOPMENT & SUPPORT'
          info='We provide end-to-end technology solutions, including web, mobile, and desktop software development, IT infrastructure development and management, technical support, and digital product deployment.'
        />

        <Cards
          Icon={Info}
          title='IT SUPPORTENGINEERING & INDUSTRIAL SERVICES'
          info='We provide engineering solutions, machinery procurement and supply across industries, solar power supply and installation, and electric vehicle (EV) solutions, including EV supply and related infrastructure.'
        />

        <Cards
          Icon={PlayCircleOutline}
          title='AUTOMOTIVE SERVICES'
          info='We operate across the automotive value chain, providing vehicle sales and importation, automobile parts supply, logistics, and electric vehicle solutions, including EV charging station development and deployment.'
        />

        <Cards
          Icon={AddShoppingCart}
          title='E-COMMERCE & DIGITAL COMMERCE'
          info='We design, develop, and manage e-commerce businesses and platforms, helping businesses optimize their processes, develop effective advertising strategies, and achieve sustainable online growth. We also operate and manage a portfolio of e-commerce ventures.'
        />
      </div>

      <div className='productspage' id='products'>
        <div className='producttitle'>
          <h2>
            Some of Our <span>Products</span>
          </h2>
          <p>We are proud to have delivered high quality solutions and services to our clients.</p>
        </div>

        <div className='productinfo'>
          {productItems.map((product) => (
            <Products
              key={product.title}
              imageUrl={product.imageUrl}
              logoUrl={product.logoUrl}
              title={product.title}
              info={product.info}
              linkUrl={product.linkUrl}
            />
          ))}
        </div>

        <div className='moreproducts'>
          <Button variant='contained' className='buttona'>
            View all Products
          </Button>
        </div>
      </div>

      <div className='snf'>
        <Client />
      </div>

      <div className='contactsection' id='contact'>
        <Contactus onOpenContact={onNavigate} />
      </div>

      <div className='testimonial'>
        <h1>Testimonials</h1>
        <p>What are our clients saying about us?</p>
        <div className='testimonialcard'>
          <ArrowBackIosIcon />
          <Testimonial
            Icon={StarRate}
            info='The delivery and execution of the job was beautiful'
            imageUrl='/client1.png'
            name='Adeyinka Oluwaseun'
            title='CEO'
          />

          <Testimonial
            Icon={StarRate}
            info='I’m amazed by the quality and diversity of  Spheres products. As someone who loves experimenting their diverse range of products have brought excitement to my baby.'
            imageUrl='/client2.png'
            name='Faadipe Timilehin'
            title='CEO'
          />

          <Testimonial
            Icon={StarRate}
            info='The delivery and execution of the job was beautiful'
            imageUrl='/client3.png'
            name='Ahmed Adekunle'
            title='CEO'
          />
          <ArrowForwardIosIcon />
        </div>
      </div>
    </div>
  );
}

export default Home